//po načtení stránky zaškrtnu vybrnaé firmy a nastavím počet vybraných

$(document).ready(function(){

    if (!window.localStorage) {
        alert('Váš prohlížeč nepodporuje odesílání poptávek');
        return;
    }
    var myStorage = window.localStorage;

    //smazat
    myStorage.removeItem("_company_demand_fid");

    var fid = myStorage.getItem('_company_demand_fid');
    if (fid) {
        var fids = fid.split(",");
        console.log('fids=' + fids);
        fids.forEach(setCompanyDemandCheckbox);

        //$('.poptat-vybrane').prop('disabled','false');
        $('.poptat-vybrane').removeAttr('disabled');
        console.log('button enabled');
    }
    function setCompanyDemandCheckbox(fid){
        if (fid) {
            console.log('set checkbox for ' + fid);
            $('#check-' + fid).prop("checked", true);
            $('#check-' + fid).prev('label').addClass( "checked" );
            var pocet_vybranych = $('#poptat_vybrane_pocet').val();
            pocet_vybranych++;
            $('#poptat_vybrane_pocet').val(pocet_vybranych);
            $('#result_poptat_vybrane_pocet').html('(' + pocet_vybranych + ')');
        }
    }
});


$('#list').on("click", ".poptavka-vybrano", function (event) {

    if (!window.localStorage) {
        alert('Váš prohlížeč nepodporuje odesílání poptávek');
        return;
    }
    var myStorage = window.localStorage;

    //$('.poptat-vybrane').prop('disabled','false');
    $('.poptat-vybrane').removeAttr('disabled');
    console.log('button enabled');
    //$('.poptat-vybrane').focus();

    pocet_vybranych = $('#poptat_vybrane_pocet').val();

    if ($(this).is(':checked')) {
        //var fid = $("#fid").val();
        var fid = myStorage.getItem('_company_demand_fid');
        if (fid == null){
            fid = '';
        }
        if (fid){
            fid += ',';
        }
//        fid += $(this).val() + ",";
        fid += $(this).val();
        $("#fid").val(fid);
        pocet_vybranych++;
        console.log('poptavka-vybrano pridano fid=' + fid);

        //Save data to myStorage
        myStorage.setItem('_company_demand_fid', fid);
        console.log('myStorage set ' + fid);

        //odblokuju tlačítko pokud je vybraná alespoň 1 firma
        if (pocet_vybranych > 0) {
            //$('.poptat-vybrane').prop('disabled','false');
            $('.poptat-vybrane').removeAttr('disabled');
            console.log('button enabled');
        }
    } else {
        //var fid = $("#fid").val();
        var fid = myStorage.getItem('_company_demand_fid');
//        fid = fid.replace($(this).val() + ',', '');
        if (fid) {
            fid = fid.replace($(this).val(), '');
            $("#fid").val(fid);
            pocet_vybranych--;
            console.log('poptavka-vybrano odebrano fid=' + fid);
            //Save data to myStorage
            myStorage.setItem('_company_demand_fid', fid);
            console.log('myStorage set ' + fid);
        }
    }
    //zablokuju tlačítko pokud není žádná firma vybraná
    if (pocet_vybranych == 0) {
        //$('.poptat-vybrane').attr('disabled', 'true');
        $('.poptat-vybrane').attr('disabled', '');
        console.log('button disabled');

    }
    $('#poptat_vybrane_pocet').val(pocet_vybranych);
    $('#result_poptat_vybrane_pocet').html('(' + pocet_vybranych + ')');


});

$('#list').on("click", ".poptat-vybrane", function (event) {
    //var fids = $('#fid').val();

    if (!window.localStorage) {
        alert('Váš prohlížeč nepodporuje odesílání poptávek');
        return;
    }
    var myStorage = window.localStorage;

    var fids = myStorage.getItem('_company_demand_fid');

    //var fids = $(".contact-form-basic-firms-select2").val();
    console.log('poptat-vybrane ' + fids);
//    alert('poptat-vybrane'+fids);

    $.ajax({
        type: 'GET',
        url: "/firmy/ajax_poptavka/",
        data: {fids: fids, galabel: 'form-sent-hromadna-poptavka'},
        beforeSend: function () {
        },
        success: function (ret) {
            console.log('poptavka loaded');
            if(ret.status) {
                $("#ajax_poptavka").html(ret.content);
                /*
                                var fid = myStorage.getItem('_company_demand_fid');
                                if (fid) {
                                    var fids = fid.split(",");
                                    fids.forEach(removeCompanyDemandCheckbox);
                                }

                                function removeCompanyDemandCheckbox(fid) {
                                    if (fid) {
                                        console.log('unset checkbox for ' + fid);
                                        $('#check-' + fid).prop("checked", false);
                                        $('#check-' + fid).prev('label').removeClass("checked");
                                    }
                                }
                */
                //odstranim firmy ze session
                //myStorage.removeItem("_company_demand_fid");

            }
        },
        complete: function () {
        }
    });

});

$('#popis').on("click", ".poptat-firmu", function (event) {
    var fids = $('#fid_detail').val();
    console.log('poptat-firmu' + fids);
//    alert('poptat-vybrane'+fids);

    $.ajax({
        type: 'GET',
        url: "/firmy/ajax_poptavka/",
        data: {fids: fids, galabel: 'form-sent-poptavka-firmy-detail'},
        beforeSend: function () {
        },
        success: function (ret) {
            console.log('poptavka loaded');
            if(ret.status) {
                $("#ajax_poptavka").html(ret.content);
            }
        },
        complete: function () {
        }
    });

});

$('#list').on("click", ".poptat-partnera-oboru", function (event) {
    //var fids = $('#fid_partner_oboru').val();
    var fids = $(this).attr('id');
    console.log('poptat-partnera-oboru fid=' + fids);
//    alert('poptat-vybrane'+fids);

    $.ajax({
        type: 'GET',
        url: "/firmy/ajax_poptavka/",
        data: {fids: fids, galabel: 'form-sent-partner-oboru-firmy'},
        beforeSend: function () {
        },
        success: function (ret) {
            console.log('poptavka loaded');
            if(ret.status) {
                $("#ajax_poptavka").html(ret.content);
            }
        },
        complete: function () {
        }
    });

});
